import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { useApp } from "@/context/AppContext";

export default function Footer() {
  const { t } = useApp();
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-10 flex flex-col md:flex-row gap-6 items-start md:items-center justify-between">
        <div className="flex items-center gap-3">
          <Logo />
          <span className="text-xs text-slate-500">© {year} Agendik · agendik.io · Ecuador</span>
        </div>
        <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
          <Link data-testid="footer-doctor-link" to="/doctor/login"
                className="text-blue-700 font-semibold hover:text-blue-800">{t.nav.doctorLogin}</Link>
          <Link data-testid="footer-partner-link" to="/socio/registro"
                className="text-slate-600 hover:text-blue-700">{t.footer.becomePartner}</Link>
          <Link data-testid="footer-about-link" to="/sobre-nosotros"
                className="text-slate-600 hover:text-blue-700">{t.footer.about}</Link>
          <Link data-testid="footer-terms-link" to="/legal/terminos"
                className="text-slate-600 hover:text-blue-700">{t.footer.terms}</Link>
          <Link data-testid="footer-privacy-link" to="/legal/privacidad"
                className="text-slate-600 hover:text-blue-700">{t.footer.privacy}</Link>
          <Link data-testid="footer-manage-link" to="/cita/gestionar"
                className="text-slate-600 hover:text-blue-700">{t.footer.manage}</Link>
          <Link data-testid="footer-admin-link" to="/admin/login"
                className="text-slate-400 hover:text-slate-700">Admin</Link>
        </nav>
      </div>
    </footer>
  );
}
